import { Component, OnInit, OnChanges, Injector } from '@angular/core';
import { Validators, FormBuilder } from '@angular/forms';
import { AppWizService } from 'src/app/core/services/app-wiz.service';
import { UtilService } from 'src/app/core/services/util.service';
import { ArtifactBaseComponent } from '../artifact-base-component';
import { AppHttpClient } from 'src/app/core/services/app-http-client.service';

@Component({
  selector: 'app-school-system-selection',
  templateUrl: './school-system-selection.component.html',
  styleUrls: ['./school-system-selection.component.scss']
})
export class SchoolSystemSelectionComponent extends ArtifactBaseComponent implements OnInit, OnChanges {

  siteTypeList: any[] = [];
  schoolSystemList: any[] = [];
  loadingSiteTypes: boolean = false;
  loadingSchoolSystems: boolean = false;

  constructor(
    private injector: Injector,
    public fb: FormBuilder,
    public override appWizService: AppWizService,
    public util: UtilService,
    public http: AppHttpClient,
  ) {
    super(injector);
    this.interalForm = this.fb.group({
      siteType: [null, [Validators.required]],
      schoolSystem: [null, [Validators.required]],
    });
    this.interalForm.get('siteType')?.valueChanges.subscribe(() => this.onSiteTypeChange());
    this.interalForm.get('schoolSystem')?.valueChanges.subscribe(() => this.onSchoolSystemChange());
    this.fetchSiteTypes();
  }

  fetchSiteTypes() {
    this.loadingSiteTypes = true;
    this.http.get("sitetypes")
      .subscribe({
        next: (res: any) => {
          this.siteTypeList = (res || []).map((i: any) => ({
            value: i.siteTypeCode,
            viewValue: i.siteTypeDescription
          }));
          this.loadingSiteTypes = false;

          // If editing existing data, reload school systems for saved site type
          if (this.jsonData?.siteTypeCode) {
            this.interalForm.patchValue({ siteType: this.jsonData.siteTypeCode }, { emitEvent: false });
            this.fetchSchoolSystems(this.jsonData.siteTypeCode);
          }
        },
        error: () => {
          this.loadingSiteTypes = false;
        }
      });
  }

  onSiteTypeChange() {
    const siteType = this.interalForm.get('siteType')?.value;
    this.interalForm.get('schoolSystem')?.reset();
    this.schoolSystemList = [];
    if (siteType) {
      this.fetchSchoolSystems(siteType);
    }
  }

  onSchoolSystemChange() {
    this.processBeforeSubmit();
    this.validateSection();
  }

  fetchSchoolSystems(siteType: string) {
    this.loadingSchoolSystems = true;
    this.http.get("sitetype", { sitetype: siteType })
      .subscribe({
        next: (res: any) => {
          this.schoolSystemList = (res || []).map((i: any) => ({
            value: JSON.parse(JSON.stringify(i)),
            viewValue: `${i.siteLongName || i.siteName} (${i.systemCode}-${i.siteCode})`
          }));
          this.loadingSchoolSystems = false;

          // If editing existing data, restore saved school system selection
          if (this.jsonData?.systemCode) {
            const saved = this.schoolSystemList.find(
              s => s.value.systemCode === this.jsonData.systemCode && s.value.siteCode === this.jsonData.siteCode
            );
            if (saved) {
              this.interalForm.patchValue({ schoolSystem: saved.value }, { emitEvent: false });
            }
          }
        },
        error: () => {
          this.loadingSchoolSystems = false;
        }
      });
  }

  initJsonData() {
    this.jsonData = this.jsonData || {};
    this.jsonData.siteTypeCode = this.jsonData.siteTypeCode || null;
    this.jsonData.siteTypeDescription = this.jsonData.siteTypeDescription || null;
    this.jsonData.systemCode = this.jsonData.systemCode || null;
    this.jsonData.systemName = this.jsonData.systemName || null;
    this.jsonData.siteCode = this.jsonData.siteCode || null;
    this.jsonData.siteName = this.jsonData.siteName || null;
    this.jsonData.siteLongName = this.jsonData.siteLongName || null;
  }

  validateJsonData() {
    this.artifact.sectionValid = !!(this.jsonData.siteTypeCode && this.jsonData.systemCode);
  }

  resetJsonData() {
    this.jsonData.siteTypeCode = null;
    this.jsonData.siteTypeDescription = null;
    this.jsonData.systemCode = null;
    this.jsonData.systemName = null;
    this.jsonData.siteCode = null;
    this.jsonData.siteName = null;
    this.jsonData.siteLongName = null;
    this.interalForm.reset();
    this.schoolSystemList = [];
  }

  override processBeforeSubmit() {
    const siteTypeCode = this.interalForm.get('siteType')?.value;
    const schoolSystem = this.interalForm.get('schoolSystem')?.value;
    const siteType = this.siteTypeList.find(s => s.value === siteTypeCode);

    this.jsonData.siteTypeCode = siteTypeCode;
    this.jsonData.siteTypeDescription = siteType?.viewValue || null;

    if (schoolSystem) {
      this.jsonData.systemCode = schoolSystem.systemCode;
      this.jsonData.systemName = schoolSystem.systemName;
      this.jsonData.siteCode = schoolSystem.siteCode;
      this.jsonData.siteName = schoolSystem.siteName;
      this.jsonData.siteLongName = schoolSystem.siteLongName;
    }
  }
}
